import { useCallback, useState } from 'react'

const useOpenable = (initialState: boolean | (() => boolean) = false) => {
	const [isOpen, setIsOpen] = useState(initialState)
	const open = useCallback(() => setIsOpen(true), [])
	const close = useCallback(() => setIsOpen(false), [])
	return [isOpen, open, close, setIsOpen] as const
}

export { useOpenable }
